import { render } from "./Sucursales-App.vue?vue&type=template&id=c4cb8a3a&scoped=true"
import script from "./Sucursales-App.vue?vue&type=script&lang=js"
export * from "./Sucursales-App.vue?vue&type=script&lang=js"

import "./Sucursales-App.vue?vue&type=style&index=0&id=c4cb8a3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4cb8a3a"]])

export default __exports__